import React, { useEffect, useState } from "react";
import { createNewGuestCard } from "./newGuestCardFirebase";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import { useNavigate } from "react-router-dom";
import {
  DatePicker,
  Form,
  Input,
  Select,
  Card,
  Checkbox,
  message,
  notification,
  Row,
  Col,
  Button,
} from "antd";
import {
  bedRooms,
  bathRooms,
  additionalOccupants,
} from "../../../../utils/Util";
import Interests from "../components/Interests";
import TextArea from "antd/es/input/TextArea";
import FormAction from "../../../../components/common/FormAction";
import Notes from "../../../../components/common/Notes";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-hot-toast";

const NewGuestCardRightBar = [];
const sources = [
  { label: "Zillow Rental Network", value: "Zillow Rental Network" },
  { label: "Zumper", value: "Zumper" },
  { label: "Apartments.com", value: "Apartments.com" },
  { label: "Lovely", value: "Lovely" },
  { label: "Website", value: "Website" },
];

function NewGuestCard() {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [interests, setInterests] = useState([{ id: uuidv4(), interest: "" }]);
  const [properties, setProperties] = useState([]);
  const [notes, setNotes] = useState([]);
  const [uploading, setuploading] = useState(false);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (companyName) {
      const propertyRef = collection(
        db,
        "companies",
        companyName,
        "properties"
      );
      const fetchProperties = async () => {
        const snapShot = await getDocs(propertyRef);
        const fetchedData = snapShot.docs.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label: doc.data().propertyNameAddress.propertyName,
          ...doc.data(),
        }));
        setProperties(fetchedData);
      };
      fetchProperties();
    }
  }, [companyName]);

  const [files, setFiles] = useState([]);

  const onFinish = (values) => {
    setuploading(true);
    const interest = interests.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const filteredNotes = notes.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    createNewGuestCard(
      values,
      companyName,
      selectedPets,
      interest,
      filteredNotes,
      files
    ).then(() => {
      toast.success("Guest Card Created SuccessFully!", 3);
      setTimeout(() => {
        setuploading(false);
        navigate("/leasing/guest-cards");
      }, 2000);
    });
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    setuploading(false);
    console.log("Failed:", errorInfo);
    message.error("Please fill in all the required fields!", 3);
  };

  const [selectedPets, setSelectedPets] = useState([]);

  const handlePetsChange = (checkedValues) => {
    setSelectedPets(checkedValues);
  };

  const [users, setusers] = useState([]);

  useEffect(() => {
    if (companyName) {
      const userRef = collection(db, "companies", companyName, "users");
      const fetchUsers = async () => {
        const snapShot = await getDocs(userRef);
        const fetchedData = snapShot.docs.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label:
            doc.data().profile.firstName + " " + doc.data().profile.lastName,
          ...doc.data(),
        }));
        setusers(fetchedData);
      };
      fetchUsers();
    }
  }, [companyName]);

  return (
    <>
      <PageHeading heading="New Guest Card" />

      <Form
        className="user-profile"
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 11 }}
        colon={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        {/* CONTACT INFORMATION */}
        <Card title="Contact Information" bordered={false} extra>
          <Form.Item
            name="firstName"
            label="First Name"
            wrapperCol={{ span: 8 }}
            rules={[
              {
                required: true,
                message: "Please fill required field!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="middleInitial"
            label="Middle Initial"
            wrapperCol={{ span: 8 }}
          >
            <Input style={{ width: 50 }} maxLength={1} />
          </Form.Item>

          <Form.Item name="lastName" label="Last Name" wrapperCol={{ span: 8 }} rules={[
              {
                required: true,
                message: "Please fill required field!",
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            wrapperCol={{ span: 8 }}
            rules={[
              {
                type: "email",
                message:
                  "Please enter a valid email address (e.g., aamirali@gmail.com)",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="phoneNumber"
            label="Phone Number"
            wrapperCol={{ span: 8 }}
          >
            <Input type="number" />
          </Form.Item>

          <Form.Item label="Source " wrapperCol={{ span: 8 }} name="source">
            <Select options={sources} />
          </Form.Item>

          <Form.Item
            label="Assign To "
            wrapperCol={{ span: 8 }}
            name={"assignTo"}
          >
            <Select
              options={users} // users
              allowClear
              showSearch
            />
          </Form.Item>
        </Card>
        {/* INTERESTS */}
        <Card title="Interests" bordered={false}>
          <Interests
            interests={interests}
            setInterests={setInterests}
            properties={properties}
          />
        </Card>
        {/* PROFILE */}
        <Card title="Profile" bordered={false}>
          <Form.Item
            label="Bedrooms"
            wrapperCol={{ span: 8 }}
            name={"numberOfBedRooms"}
          >
            <Select>
              {bedRooms.map((bedRooms) => {
                return (
                  <Select.Option key={bedRooms} value={bedRooms}>
                    {bedRooms}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="Bathrooms"
            wrapperCol={{ span: 8 }}
            name={"bathrooms"}
          >
            <Select>
              {bathRooms.map((bathRooms) => {
                return (
                  <Select.Option key={bathRooms} value={bathRooms}>
                    {bathRooms}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="Max Rent"
            wrapperCol={{ span: 8 }}
            name={"maxRent"}
            rules={[
              {
                pattern: /^[0-9]+$/,
                message: "Please enter numbers only",
              },
            ]}
          >
            <Input type="number" />
          </Form.Item>

          <Form.Item
            label="Move Inn"
            wrapperCol={{ span: 8 }}
            name={"moveInDate"}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            label="Additional Occupants"
            wrapperCol={{ span: 8 }}
            name={"additionalOccupants"}
          >
            <Select>
              {additionalOccupants.map((additionalOccupants) => {
                return (
                  <Select.Option
                    key={additionalOccupants}
                    value={additionalOccupants}
                  >
                    {additionalOccupants}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="Monthly Income"
            wrapperCol={{ span: 8 }}
            name={"monthlyIcom"}
            rules={[
              {
                pattern: /^[0-9]+$/,
                message: "Please enter numbers only",
              },
            ]}
          >
            <Input prefix="$" type="number" />
          </Form.Item>

          <Form.Item
            label="Credit Score"
            wrapperCol={{ span: 8 }}
            name={"creditStore"}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Pets" wrapperCol={{ span: 8 }} name="pets">
            <Checkbox.Group onChange={handlePetsChange}>
              <Checkbox value="Cat">Cat</Checkbox>
              <Checkbox value="Dog">Dog</Checkbox>
              <Checkbox value="Other">Other</Checkbox>
            </Checkbox.Group>
          </Form.Item>
        </Card>
        {/* ADDITIONAL COMMENTS */}
        <Card title="Additional Comments" bordered={false}>
          <Form.Item
            label="Comments"
            wrapperCol={{ span: 8 }}
            name={"comments"}
          >
            <TextArea rows={4} />
          </Form.Item>
        </Card>
        {companyName ? (
          <Notes
            notesForCollection="guestCards"
            notesForCollectionId=""
            companyName={companyName}
            notes={notes}
            setNotes={setNotes}
          />
        ) : null}
        <AttachmentsUpload setFiles={setFiles} /> <br />
        <Row gutter={16}>
          <Col>
            <Button type="primary" htmlType="submit" disabled={uploading}>
              {uploading ? "wait..." : "Save"}
            </Button>
          </Col>
          <Col>
            <Button
              onClick={() => {
                navigate("/leasing/guest-cards");
              }}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
      <div className="RightSidebar">
        <RightBar RightBarData={NewGuestCardRightBar} />
      </div>
    </>
  );
}

export default NewGuestCard;
